<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- <div class="col-xl-12" v-show="data.itens.length == 0 && data.loaded">
                            <div class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>                            
                        </div>   -->                        
                        <div class="col-xl-12">
                            <ul class="list-1">
                                <li>
                                    <i class="material-icons">event</i>26/01/2021
                                    <ul class="list-1">
                                        <li>
                                            <p class="margin-bottom-0">
                                                Você sentiu ou está sentindo algum enjoo hoje? <b>Senti, mas já passou</b>
                                            </p>
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Como está o seu apetite hoje? <b>Normal</b>
                                            </p>
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Pergunta de exemplo? <b>Sim</b>
                                            </p>                                        
                                        </li>                                        
                                    </ul>                                                                                                                                                                
                                </li>
                                <li>
                                    <i class="material-icons">event</i>25/01/2021
                                    <ul class="list-1">
                                        <li>
                                            <p class="margin-bottom-0">
                                                Você sentiu ou está sentindo algum enjoo hoje? <b>Não</b>
                                            </p>                                        
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Como está o seu apetite hoje? <b>Péssimo</b>
                                            </p>                                        
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Pergunta de exemplo? <b>Não</b>
                                            </p>                                        
                                        </li>                                        
                                    </ul>                                                                                                                                                                
                                </li>  
                                <li>
                                    <i class="material-icons">event</i>24/01/2021
                                    <ul class="list-1">
                                        <li>
                                            <p class="margin-bottom-0">
                                                Você sentiu ou está sentindo algum enjoo hoje? <b>Senti, mas já passou</b>
                                            </p>                                        
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Como está o seu apetite hoje? <b>Normal</b>
                                            </p>                                        
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Pergunta de exemplo? <b>Sim</b>
                                            </p>                                        
                                        </li>                                        
                                    </ul>                                                                                                                                                                
                                </li>
                                <li>
                                    <i class="material-icons">event</i>23/01/2021
                                    <ul class="list-1">
                                        <li>
                                            <p class="margin-bottom-0">
                                                Você sentiu ou está sentindo algum enjoo hoje? <b>Não</b>
                                            </p>                                        
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Como está o seu apetite hoje? <b>Péssimo</b>
                                            </p>                                        
                                        </li>
                                        <li>
                                            <p class="margin-bottom-0">
                                                Pergunta de exemplo? <b>Não</b>
                                            </p>                                        
                                        </li>                                        
                                    </ul>                                                                                                                                                                
                                </li>                                                                
                            </ul>                            
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Sintomas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {       
        // getBase64Arquivo: function(event) {
        //     var self            = this;
        //     if (event.target.files[0]) {
        //         loading.show();
        //         reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
        //             blobToBase64(blob, function(result) {
        //                 // loading.hide();
        //                 self.form.arquivo   = result;
        //                 var nome            = prompt("Qual o nome do arquivo?", event.target.files[0].name);
        //                 if (!nome) {
        //                     return false;
        //                 }
        //                 self.form.nome      = nome;
        //                 self.form.empresaCod= event.target.dataset.empresacod;
        //                 self.$forceUpdate();
        //                 self.submit();
        //             });
        //         }); 
        //     }   
        // },         
        submit: function() {
            var self            = this;
            console.log("submit()", self.form);
            
            // self.loading.submit = true;
            loading.show();
                
            axios.post("api/arquivos.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                // loading.hide();
                // alert(response.data.message);
                self.get().then(function() {
                    self.form.arquivo   = null;
                    self.form.nome      = "";
                    self.$forceUpdate();
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        editar: function(cod, nome) {
            var self            = this;
            console.log("editar()");
            
            // self.loading.submit = true;
            var form            = JSON.parse(JSON.stringify(self.form));
            form.cod            = cod;
            var novoNome        = prompt("Editar o nome do arquivo", nome);
            if (!novoNome) {
                return false;
            }
            form.nome      = novoNome;
            loading.show();

            axios.put("api/arquivos.php", form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                // loading.hide();
                // alert(response.data.message);
                self.get().then(function() {
                    loading.hide();
                }).catch(function() {
                    loading.hide();
                });
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },          


        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/arquivos.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });                 
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },             
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/arquivos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        // loading.show();

        // Promise.all([
        //     self.get()
        // ]).then(function() {
        
        //     self.$forceUpdate();
        //     loading.hide();
            
        // }).catch(function(error) {
            loading.hide();
        // });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
    }
    .dashboard-status-button i {
        color: #fff;
        top: -3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sintomas.vue